import { AttachmentGroup } from "@rms-types/modules/attachment-group/entities/attachment-group";

import { attachmentGroupEndpoint } from "@/constants";
import { getSnackbarMessages } from "@/helpers";
import { UsePostOptions, usePost } from "@/hooks";

export function useCreateAttachmentGroup(options: UsePostOptions<AttachmentGroup> = {}) {
  const endpoint = attachmentGroupEndpoint.attachmentGroup;
  const { triggerPostErrorMessage } = getSnackbarMessages("Attachment");

  const {
    mutate,
    error: createAttachmentGroupError,
    isPending: isCreateAttachmentGroupPending,
    ...rest
  } = usePost({
    endpoint,
    options: {
      ...options,
      onError: (error, variables, context) => {
        options?.onError && options.onError(error, variables, context);
        triggerPostErrorMessage(error);
      },
    },
  });

  const createAttachmentGroup = (mutateOptions: UsePostOptions<AttachmentGroup> = {}) =>
    mutate({ payload: {} }, mutateOptions);

  return {
    createAttachmentGroup,
    isCreateAttachmentGroupPending,
    createAttachmentGroupError,
    ...rest,
  };
}
